import { componentResize, componentCheckSize } from "../../../utils/helperServices";
import styles from "./DeliveryOptionTitle.module.scss";
import config from "../../../config/index";
import { useState } from "react";

const DeliveryOptionTitle = (content) => {
  const [showInfo, setShowInfo] = useState(false);
  const env = config.env;
  const isMobile = componentResize();
  const isTablet = componentCheckSize() <= 992;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const items = ((content?.content))[0]?.description;
  const title = ((content?.content))[0]?.title;
  if (!items || !title) {
    return null;
  }
  return (
    <div className={`${styles["delivery-option-step__infobox-wraper"]} ${!showInfo ? styles["wraper-height"] : ""}`}>
      <p className={!showInfo ? styles["delivery-option-step__subtitle-collapse"] : styles["delivery-option-step__subtitle"]}>
        <span onClick={() => setShowInfo((show) => !show)}>
          {!showInfo && (isMobile || isTablet) && (<p><strong>{title}</strong></p>)}
          {(isMobile || isTablet) && (<img
            src={`${imagePrefix}/assets/images/collapsible.svg`}
            className={`${
              showInfo && styles["delivery-option-step__icon-hide"]
            }`}
          />)}
        </span>
      </p>
      <p
        className={`${styles["delivery-option-step__infobox"]} ${
          !showInfo && styles["delivery-option-step__infobox-hide"]
        }`}
        dangerouslySetInnerHTML={{ __html: items }}
      />
    </div>
  );
};

export default DeliveryOptionTitle;
